/* eslint-disable no-console */
export const logger = {
  info: (message: string, meta?: Record<string, unknown>) => {
    if (import.meta.env.PROD) {
      console.log(
        JSON.stringify({
          level: 'info',
          timestamp: new Date().toISOString(),
          message,
          ...meta,
        }),
      );
    } else {
      console.log(`ℹ️ ${message}`, meta || '');
    }
  },

  warn: (message: string, meta?: Record<string, unknown>) => {
    if (import.meta.env.PROD) {
      console.warn(
        JSON.stringify({
          level: 'warn',
          timestamp: new Date().toISOString(),
          message,
          ...meta,
        }),
      );
    } else {
      console.warn(`⚠️ ${message}`, meta || '');
    }
  },

  error: (message: string, error?: Error, meta?: Record<string, unknown>) => {
    if (import.meta.env.PROD) {
      console.error(
        JSON.stringify({
          level: 'error',
          timestamp: new Date().toISOString(),
          message,
          error: error?.message,
          stack: error?.stack,
          ...meta,
        }),
      );
    } else {
      console.error(`❌ ${message}`, error, meta || '');
    }
  },
};
